import axios from '@/plugins/axios'
import { AxiosResponse } from 'axios'

export default {
    checkToken(token: string): Promise<AxiosResponse<IServerResponse<any>>> {
        return axios.get(`/api/v1/token_user_client/check?token=${token}`)
    },
}
